<div class="collapsible-wrapper">
	<div class="collapsible-content">
		<div class="collapsible-header" (click)="clickEventHandler()">
			<div class="collapsible-header-img flex-aligned">
				<div class="img-wrapper">
					<img alt="cargando imagen" [src]="image" />
				</div>
				<div class="collapsible-header-title flex-aligned">
					<h5 class="mb-0">{{ title }}</h5>
				</div>
			</div>
			<div class="collapsible-indicator flex-aligned flex-right">
				<i class="material-icons">{{ indicatorIcon }}</i>
			</div>
		</div>
		<div class="collapsible-body" #body>
			<ng-content></ng-content>
		</div>
	</div>
</div>
